import { observable, action, computed } from "mobx";

export const PENDING_ANIMATION_STATES = {
  PENDING_TO_INVISIBLE: 0,
  INVISIBLE_TO_NORMAL: 1,
  NORMAL_TO_INVISIBLE: 2,
  INVISIBLE_TO_PENDING: 3,
};

export const PENDING_ANIMATION_MODES = {
  PENDING_CHECKING: 0,
  PENDING_REFUND: 1
}

export const PENDING_ANIMATION_TEXT = {
  PENDING_CHECKING: 'Pending Check-In',
  PENDING_REFUND: 'SEE CASHIER'
}

export default class PendingAnimationStore {
  @observable currentAnimationState = PENDING_ANIMATION_STATES.PENDING_TO_INVISIBLE;
  animationInterval;

  constructor() {
    this.animationInterval = setTimeout(this.changeAnimationState, 1000);
  }

  @action
  changeAnimationState = () => {
    this.currentAnimationState++;
    if (this.currentAnimationState > PENDING_ANIMATION_STATES.INVISIBLE_TO_PENDING) {
      this.currentAnimationState = PENDING_ANIMATION_STATES.PENDING_TO_INVISIBLE;
    }

    if (this.isTurningInvisible) {
      setTimeout(this.changeAnimationState, 500);
    }
    else {
      setTimeout(this.changeAnimationState, 2000);
    }
  };

  // Text should show pending when it's transitioning from pending state to invisible state and when it's transitioning from invisible state to pending state
  @computed
  get shouldDisplayPendingText() {
    return (this.currentAnimationState === PENDING_ANIMATION_STATES.INVISIBLE_TO_PENDING || this.currentAnimationState === PENDING_ANIMATION_STATES.PENDING_TO_INVISIBLE);
  };

  // Flag to tell if it's current state is switching to invisible state or not (used to switch CSS property to actually do the animation)
  @computed
  get isTurningInvisible() {
    return (this.currentAnimationState === PENDING_ANIMATION_STATES.PENDING_TO_INVISIBLE || this.currentAnimationState === PENDING_ANIMATION_STATES.NORMAL_TO_INVISIBLE);
  }
}



// WEBPACK FOOTER //
// ./src/stores/PendingAnimationStore.js